<section class="perfil-shell" [class.perfil-shell--section-viewport]="sectionViewport"
  [class.perfil-shell--hide-site-footer]="hideSiteFooter || sectionViewport"
  [class.perfil-shell--sticky-header]="stickyHeader"
  [class.perfil-shell--compact-body]="compactBody"
  [class.perfil-shell--has-security-banner]="showSecurityBanner">
  <microempresario-header></microempresario-header>

  <div class="perfil-shell__body">
    <div class="perfil-shell__container">
      @if (showGreeting) {
      <header class="perfil-shell__greeting">
        <div class="perfil-shell__greeting-text">
          @if (userName) {
          <h1 class="perfil-shell__user">{{ userName }}</h1>
          }
          @if (subtitle) {
          <p class="perfil-shell__subtitle">{{ subtitle }}</p>
          }
        </div>

        @if (ctaLabel) {
        <button type="button" class="perfil-shell__cta" id="btn-perfil-solicitar-credito" [disabled]="ctaDisabled"
          (click)="onCtaClick()">
          {{ ctaLabel }}
        </button>
        }
      </header>
      }

      <div class="perfil-shell__content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  @if (showGreeting || showBubbles) {
    <div class="perfil-shell__bubbles" [class.perfil-shell__bubbles--landing]="showCoins" aria-hidden="true">
      <span class="perfil-shell__bubble perfil-shell__bubble--lg"></span>
      <span class="perfil-shell__bubble perfil-shell__bubble--sm"></span>
      @if (showCoins) {
      <img class="perfil-shell__coin perfil-shell__coin--lg" src="assets/img/perfil/moneda-lg.svg" alt="" width="72"
        height="66" />
      <img class="perfil-shell__coin perfil-shell__coin--sm" src="assets/img/perfil/moneda-sm.svg" alt="" width="50"
        height="46" />
      }
    </div>
  }

  <ng-content select="[perfilSectionFooter]"></ng-content>

  @if (showSecurityBanner) {
    <app-footer-public variant="compact"></app-footer-public>
  }

  <app-home-site-footer [skipCms]="skipFooterCms"></app-home-site-footer>
</section>